<template>
  <iframe
      :src="'/static/pdfjs-3.2.146-dist/web/viewer.html?file=' + url"
      @load="onIframeLoad"
      ref="pdfIframe"
  />
</template>

<script>
export default {
  name: "PdfView",
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      show: {
        previewPdfDialog: false,
      },
    };
  },
  methods: {
    onIframeLoad() {
      const iframe = this.$refs.pdfIframe;
      const iframeWindow = iframe.contentWindow;

      if (iframeWindow.PDFViewerApplication) {
        iframeWindow.document.addEventListener("click", this.handleIframeClick);
      } else {
        console.error("PDFViewerApplication is not available.");
      }
    },
    handleIframeClick(event) {
      const iframe = this.$refs.pdfIframe;
      const iframeWindow = iframe.contentWindow;
      const pdfViewer = iframeWindow.PDFViewerApplication.pdfViewer;

      // 获取当前显示的页面索引（从0开始）
      const currentPageIndex = pdfViewer.currentPageNumber - 1;
      const pageView = pdfViewer.getPageView(currentPageIndex);

      if (pageView) {
        const canvas = pageView.canvas;
        const canvasRect = canvas.getBoundingClientRect();

        // 计算点击位置相对于当前页面Canvas的坐标
        const x = event.clientX - canvasRect.left;
        const y = event.clientY - canvasRect.top;

        // 转换为PDF坐标（相对于当前页面的左下角）
        const pdfPoint = pageView.viewport.convertToPdfPoint(x, y);

        // 发射事件，包含坐标和当前页码（从1开始）
        this.$emit("iframe-click", {
          x: pdfPoint[0],
          y: pdfPoint[1],
          page: currentPageIndex + 1  // 转换为1-based页码
        });
      } else {
        console.error("PDF page view not found.");
      }
    }
  },
};
</script>

<style scoped>
iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>